import { formatMoney } from '../../lib/formatters.ts'
import { safeStatementPdfHref } from './sorenAnswerCards.js'

type Money = { formatted?: string; amount?: number } | null | undefined

type ProjectRow = {
  project_name?: string
  outstanding?: Money
}

export type StatementDigest = {
  owner_name?: string | null
  download_url?: string | null
  report_url?: string | null
  outstanding?: Money
  summary?: { outstanding?: Money; owner_name?: string | null } | null
  projects?: ProjectRow[] | null
}

function moneyText(m: Money): string {
  if (m?.formatted) return m.formatted
  if (m?.amount != null) return formatMoney(Number(m.amount) || 0)
  return '$0.00'
}

export default function SorenStatementAnswerCard({
  digest,
  onOpenReport,
}: {
  digest?: StatementDigest | null
  onOpenReport?: (href: string) => void
}) {
  const owner = digest?.owner_name || digest?.summary?.owner_name || 'Owner'
  const projects = Array.isArray(digest?.projects) ? digest.projects : []
  const total = moneyText(digest?.outstanding || digest?.summary?.outstanding)
  const href = safeStatementPdfHref(digest?.download_url)
  const reportHref = digest?.report_url
    || `/reports/owner-statement?owner=${encodeURIComponent(owner)}`

  return (
    <div className="soren-statement-answer" data-testid="soren-statement-answer">
      <h3>Owner statement · {owner}</h3>
      <ul className="soren-fact-list">
        {projects.map((p, i) => (
          <li key={`${p.project_name || 'p'}-${i}`} data-testid="soren-statement-project">
            <span>{p.project_name || 'Project'}</span>
            <strong>{moneyText(p.outstanding)}</strong>
          </li>
        ))}
      </ul>
      <p data-testid="soren-statement-total">
        <span>Total</span> <strong className="money">{total}</strong>
      </p>
      {href ? (
        <a className="cr-btn dark" data-testid="soren-statement-download" href={href}>
          Download PDF
        </a>
      ) : null}
      <button
        type="button"
        className="cr-btn"
        data-testid="soren-open-statement"
        onClick={() => onOpenReport?.(reportHref)}
      >
        Open statement
      </button>
    </div>
  )
}
